import { Locale } from '@ps-smart-cp/ppfw-client';

const treatmentFixedAssetControlNameConfig = {
  expenseProcessing: new Map([
    [Locale.ja, '費用処理する'],
    [Locale.en, 'Expense Processing'],
  ]),
  noExpenseProcessing: new Map([
    [Locale.ja, '費用処理しない'],
    [Locale.en, 'No Expense Processing'],
  ]),
  noExpenseProcessingIFRS: new Map([
    [Locale.ja, 'IFRSのみ費用処理しない'],
    [Locale.en, 'No Expense Processing under IFRS'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { treatmentFixedAssetControlNameConfig };
